const CATEGORIAS = [
    "Veterinaria", "Mascotas", "Lavandería", "Jardinería", "Aseo",
    "Educación", "Construcción", "Transporte", "Eventos", "Legal",
    "Belleza", "Salud", "Digital", "Floristería", "Chef a domicilio",
    "Deporte & Fitness", "Hogar & Reparaciones", "Fotografía & Video",
    "Peluquería & Barbería", "Contabilidad & Finanzas", "Cuidado de personas",
];

const PERIODOS = [
    { key: "hoy", label: "Hoy",            icon: "bi-sun"            },
    { key: "7d",  label: "Últimos 7 días",  icon: "bi-calendar-week"  },
    { key: "14d", label: "Últimos 14 días", icon: "bi-calendar2-week" },
    { key: "30d", label: "Últimos 30 días", icon: "bi-calendar-month" },
    { key: "",    label: "Todo el tiempo",  icon: "bi-infinity"       },
];

const PAQUETES = ["Básico", "Premium", "Avanzado"];

export const FILTROS_RESERVAS_VACIO = {
    categoria:  "",
    periodo:    "",
    paquete:    "",
    conReclamo: false,
};

function FiltrosReservas({ filtros, onChange }) {

    const hayFiltros = filtros.categoria !== "" || filtros.periodo !== "" || filtros.paquete !== "" || filtros.conReclamo;

    return (
        <div className="d-flex flex-column gap-2 mb-3">

            {/* Período */}
            <div className="d-flex align-items-center gap-2 flex-wrap">
                <span className="text-muted small fw-semibold flex-shrink-0" style={{ fontSize: "0.8rem", minWidth: 80 }}>Período:</span>
                <div className="d-flex gap-1 flex-wrap">
                    {PERIODOS.map(({ key, label, icon }) => (
                        <button
                            key={key || "todo"}
                            type="button"
                            className={`btn btn-sm rounded-pill ${filtros.periodo === key && key !== "" ? "btn-dark" : "btn-outline-secondary"}`}
                            style={{ fontSize: "0.75rem" }}
                            onClick={() => onChange({ ...filtros, periodo: filtros.periodo === key ? "" : key })}
                        >
                            <i className={`bi ${icon} me-1`}></i>{label}
                        </button>
                    ))}
                </div>
            </div>

            {/* Tipo de paquete */}
            <div className="d-flex align-items-center gap-2 flex-wrap">
                <span className="text-muted small fw-semibold flex-shrink-0" style={{ fontSize: "0.8rem", minWidth: 80 }}>Paquete:</span>
                <div className="d-flex gap-1 flex-wrap">
                    {PAQUETES.map(p => (
                        <button
                            key={p}
                            type="button"
                            className={`btn btn-sm rounded-pill ${filtros.paquete === p ? "btn-dark" : "btn-outline-secondary"}`}
                            style={{ fontSize: "0.75rem" }}
                            onClick={() => onChange({ ...filtros, paquete: filtros.paquete === p ? "" : p })}
                        >
                            {p}
                        </button>
                    ))}
                </div>
            </div>

            {/* Con reclamo */}
            <div className="d-flex align-items-center gap-2 flex-wrap">
                <span className="text-muted small fw-semibold flex-shrink-0" style={{ fontSize: "0.8rem", minWidth: 80 }}>Alertas:</span>
                <button
                    type="button"
                    className={`btn btn-sm rounded-pill ${filtros.conReclamo ? "btn-danger" : "btn-outline-secondary"}`}
                    style={{ fontSize: "0.75rem" }}
                    onClick={() => onChange({ ...filtros, conReclamo: !filtros.conReclamo })}
                >
                    <i className="bi bi-exclamation-triangle me-1"></i>Con reclamo abierto
                </button>
            </div>

            {/* Categoría */}
            <div className="d-flex align-items-start gap-2 flex-wrap">
                <span className="text-muted small fw-semibold flex-shrink-0" style={{ fontSize: "0.8rem", minWidth: 80, paddingTop: 4 }}>Categoría:</span>
                <div className="d-flex gap-1 flex-wrap">
                    {CATEGORIAS.map(cat => (
                        <button
                            key={cat}
                            type="button"
                            className={`btn btn-sm rounded-pill ${filtros.categoria === cat ? "btn-dark" : "btn-outline-secondary"}`}
                            style={{ fontSize: "0.75rem" }}
                            onClick={() => onChange({ ...filtros, categoria: filtros.categoria === cat ? "" : cat })}
                        >
                            {cat}
                        </button>
                    ))}
                </div>
            </div>

            {/* Limpiar filtros */}
            {hayFiltros && (
                <div>
                    <button
                        type="button"
                        className="btn btn-sm btn-outline-danger rounded-pill"
                        style={{ fontSize: "0.75rem" }}
                        onClick={() => onChange({ ...FILTROS_RESERVAS_VACIO })}
                    >
                        <i className="bi bi-x-circle me-1"></i>Limpiar filtros
                    </button>
                </div>
            )}
        </div>
    );
}

export default FiltrosReservas;
